interface CardHeaderProps {
  budgetNumber: string;
  version: string;
}

const CardHeader = ({ budgetNumber, version }: CardHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-3">
      <span className="font-bold text-size-14">Orçamento: {budgetNumber}</span>
      <span className="text-size-14 text-gray-600">{version}</span>
    </div>
  );
};

export default CardHeader;



